import React from 'react';

const ImageJs = (props) => (
    <svg {...props} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <circle id="path-1" cx="28" cy="28" r="28"/>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-559 -369)">
                <g transform="translate(120 189)">
                    <g transform="translate(54 180)">
                        <g transform="translate(385)">
                            <use fill="#0084FF" xlinkHref="#path-1"/>
                            <use className="image-filter" fillOpacity="0.2" fill="#000"
                                xlinkHref="#path-1"/>
                            <path d="M29.3913016,32.4567974 L25.8260944,28.6543287 L18.8695584,32.4567974 L26.5217424,24.3333333 L30.1739168,28.1358021 L37.0434856,24.3333333 L29.3913016,32.4567974 Z M28.0000056,15 C20.2679992,15 14,20.8036855 14,27.9629636 C14,32.0424196 16.0358252,35.6812115 19.2173936,38.0574044 L19.2173936,43 L23.9842637,40.3838246 C25.2564403,40.7358967 26.6041793,40.9259384 28.0000056,40.9259384 C35.7320121,40.9259384 42,35.1222416 42,27.9629636 C42,20.8036855 35.7320121,15 28.0000056,15 Z"
                                fill="#FFF"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ImageJs;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/assets/FbMessenger.js